var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goods" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-form",
          {
            attrs: {
              model: _vm.form,
              "label-width": "90px",
              "label-position": "top",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "商品来源：" } },
              [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.changeType },
                    model: {
                      value: _vm.form.goodsType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "goodsType", $$v)
                      },
                      expression: "form.goodsType",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "1" } }, [
                      _vm._v("指定拼团ID"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: "2" } }, [
                      _vm._v("所有未完结拼团"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { type: "textarea", rows: 4 },
                  model: {
                    value: _vm.form.skuId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "skuId", $$v)
                    },
                    expression: "form.skuId",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticStyle: { color: "#999" } }, [
                  _vm._v("商品以,分割，如商品已下架则不展示！"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "单页商品数量：" } },
              [
                _c("el-input-number", {
                  attrs: { placeholder: "请输入", min: 0 },
                  model: {
                    value: _vm.form.pageNum,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "pageNum", $$v)
                    },
                    expression: "form.pageNum",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "主题色：" } },
              [
                _c("el-color-picker", {
                  attrs: { "show-alpha": "" },
                  model: {
                    value: _vm.form.pincolor,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "pincolor", $$v)
                    },
                    expression: "form.pincolor",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticStyle: { color: "#999" } }, [
                  _vm._v("主题色为标签、按钮、拼团价的颜色"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-divider"),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("span", [_vm._v("边距：")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "左侧" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      model: {
                        value: _vm.form.pinPadding.pl,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.pinPadding, "pl", $$v)
                        },
                        expression: "form.pinPadding.pl",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "顶侧" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      model: {
                        value: _vm.form.pinPadding.pt,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.pinPadding, "pt", $$v)
                        },
                        expression: "form.pinPadding.pt",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "右侧" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      model: {
                        value: _vm.form.pinPadding.pr,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.pinPadding, "pr", $$v)
                        },
                        expression: "form.pinPadding.pr",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "底侧" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      model: {
                        value: _vm.form.pinPadding.pb,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.pinPadding, "pb", $$v)
                        },
                        expression: "form.pinPadding.pb",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }